import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Subscription, lastValueFrom } from 'rxjs';
import { BuilderRequest } from 'src/app/models/requests';
import { ToastService } from 'src/app/services/toast.service';
import { LoggingService } from 'src/app/services/logging.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalOpenerService } from 'src/app/modals/modal-opener.service';
import { OrganisationPlugins } from 'src/app/constants/settings.enum';

@Component({
  selector: 'app-adddocumentsdropzone',
  templateUrl: './adddocumentsdropzone.component.html'
})
export class AddDocumentsDropzoneComponent implements OnInit {

  @Input('Request') request!: BuilderRequest;
  @Input('SupportedDocumentTypes') supportedDocumentTypes: string[] | undefined = [];
  @Input('MaxDocumentAmount') maxDocumentAmount: number | undefined = 0;
  @Output('OnFileSelected') onFileSelected = new EventEmitter();
  @Output('getRequest') getRequest: EventEmitter<string> = new EventEmitter<string>();
  @Output('UploadCloudDocuments') uploadCloudDocuments = new EventEmitter();
  disabled = true;
  plugins: any[] = [];
  neededPlugins: any[] = [OrganisationPlugins.SharePoint, OrganisationPlugins.OneDrive, OrganisationPlugins.Teams];
  user!: User;
  usersubscription: Subscription;
  cloudlocations: any;
  uploadProgress: number = 0;
  showMSplugins: boolean = false;
  translations:any = <any>{};

  constructor(config: NgbProgressbarConfig, private authenticationService: AuthenticationService, 
    private organisationApiClient: OrganisationApiClient, private toastService: ToastService,
    private loggingService: LoggingService, private translateService: TranslateService, private modalOpenerService: ModalOpenerService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    config.striped = true;
		config.animated = true;

    this.usersubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.user = data;
    });
    this.organisationApiClient.getEnabledPlugins(this.user.organisationGuid).subscribe({
      next: (data:any) => {
        this.plugins = data;
        if (this.plugins.filter(s => this.neededPlugins.includes(s.code)).length>0) {
          this.showMSplugins = true;
        }
      }
    });
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.Error',
      'CloudLocations.ImportFilesFailed'
    ]).subscribe(translation => {
      this.translations.error = translation['Toasts.Error'];
      this.translations.toastsImportFilesFailed = translation['CloudLocations.ImportFilesFailed'];
    });
  }
  
  OnFileSelected(event:any){
    this.onFileSelected.emit(event);
    // Set event.target.value to null, so a file with the same name can be uploaded after deleting it from the request.
    event.target.value = null;
  }
  onDragOver(event: any) {
    event.preventDefault();
  }

  addDocumentsCloudLocation() {
    const modalRef = this.modalOpenerService.Open_CloudDocumentUpload(this.request.id, this.plugins, this.supportedDocumentTypes);    
    modalRef.componentInstance.setUrl.subscribe((requestId: string) => {
      this.getRequest.emit(requestId);
    });
    modalRef.componentInstance.close.subscribe(async (event:any) => {
      modalRef.close();
      try {
        if (!event || !event.externalFiles || event.externalFiles.length == 0) return;
        this.uploadCloudDocuments.emit(event);
      } catch (error: any) {
        this.loggingService.logException(error);
        this.toastService.showDefault(this.translations.error, this.translations.toastsImportFilesFailed);
      }
    });
  }

}
